module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('confirm-modal', {
    attrs: {
      "id": "confirm-reset-same-flow",
      "title": "Resetar contato no fluxo"
    },
    on: {
      "confirm-modal-confirm": _vm.callResetContact
    }
  }, [_c('br'), _c('div', {
    staticClass: "text-center"
  }, [_c('div', [_vm._v("O contato já está no fluxo e ações podem ter sido realizadas para ele. Você deseja reiniciar o contato no fluxo?")]), _c('br'), _c('div', [_c('strong', {
    staticClass: "dark-red-color"
  }, [_vm._v("Atenção")]), _vm._v(": Ao continuar, o lead voltará ao início do fluxo.")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-17d1697a!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/shared/modals/reset_contact_modal.vue
// module id = 1024
// module chunks = 1